import Vue from "vue";
import axios from "axios";
import "./plugins/vuetify";
import "./plugins/vuelidate";
import "./plugins/filters";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import LabelAndInfo from '@/components/Base/LabelAndInfo';
import CardContentOnly from '@/components/Base/CardContentOnly';
import InfoTooltip from '@/components/Base/InfoTooltip';

Vue.component('BaseLabelAndInfo', LabelAndInfo);
Vue.component('BaseCardContentOnly', CardContentOnly);
Vue.component('BaseInfoTooltip', InfoTooltip);

Vue.config.productionTip = false;
Vue.prototype.$vatAmount = 0.20;

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
  created() {
    store.dispatch('globals/fetchCurrentUser');
  }
}).$mount("#app");
